console.log("Coded With \u2764\uFE0F By Sam!");
const changeHamburgerIcon = (nav)=>{
    const navToggler = nav.querySelector('[data-nav-toggler] > use');
    if (navToggler.getAttribute('href') === './assets/icons/sprite.svg#hamburger') navToggler.setAttribute('href', './assets/icons/sprite.svg#cross');
    else navToggler.setAttribute('href', './assets/icons/sprite.svg#hamburger');
};
const addOrRemoveTabIndex = (nav)=>{
    const navLinks = [
        ...nav.querySelectorAll('.nav a')
    ];
    const query = 'button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const focusableElements = [
        ...document.querySelectorAll(query)
    ];
    if (nav.classList.contains('nav--opened')) {
        focusableElements.forEach((item)=>item.setAttribute('tabindex', '-1'));
        navLinks.forEach((item)=>item.removeAttribute('tabindex'));
        return;
    }
    if (nav.classList.contains('nav--closed')) {
        focusableElements.forEach((item)=>item.removeAttribute('tabindex'));
        navLinks.forEach((link)=>link.setAttribute('tabindex', '-1'));
        return;
    }
};
const togglePreventScroll = (element)=>{
    element.classList.toggle('prevent-scroll');
};
const handleNavigationToggle = ()=>{
    const nav = document.querySelector('[data-nav]');
    nav.classList.toggle('nav--opened');
    nav.classList.toggle('nav--closed');
    changeHamburgerIcon(nav);
    addOrRemoveTabIndex(nav);
    togglePreventScroll(document.body);
};
const handleNavigation = (e)=>{
    const isNavigationLink = e.target.matches('[data-nav-link]');
    const currentListItem = e.target.closest('[data-nav-links] .list__item');
    if (!isNavigationLink && currentListItem === null) return;
    document.querySelector('[data-nav-links] .list__item.active').classList.remove('active');
    currentListItem.classList.add('active');
    handleNavigationToggle();
};
const navbar = document.querySelector('[data-nav]');
let previousScrollPosition = 0;
const showHideNavbar = ()=>{
    const currentScrollPosition = window.scrollY;
    if (currentScrollPosition > previousScrollPosition) {
        previousScrollPosition = currentScrollPosition;
        navbar.style.top = '-100px'; // Hide navbar.
        return;
    }
    navbar.style.top = '0'; // Show navbar.
    previousScrollPosition = currentScrollPosition;
};
const getFormValues = (form)=>{
    const inputs = form.querySelectorAll('.input, .text-area');
    const formData = {};
    for (const input of inputs)formData[input.name] = input.value;
    return formData;
};
const validateContactFormData = (formData)=>{
    const { name, email, subject, message } = formData;
    const errors = {};
    const emailRegEx = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!name.trim() || name.trim().length < 3) errors.name = 'Invalid name length!';
    if (!email.trim() || !emailRegEx.test(email.trim())) errors.email = 'Please enter valid email address!';
    if (!subject.trim()) errors.subject = 'Please specify a subject!';
    if (!message.trim()) errors.message = 'Message can not be empty!';
    else if (message.trim().length < 20) errors.message = 'Message length can not be less than 20 characters!';
    return errors;
};
const setError = ({ element, message })=>{
    const parentElement = element.parentNode;
    const inputError = document.createElement('p');
    inputError.classList.add('input-error');
    inputError.innerText = message;
    parentElement.insertBefore(inputError, element);
};
const removeError = (element)=>{
    const parentElement = element.parentNode;
    const inputError = parentElement.querySelector('.input-error');
    if (inputError) inputError.remove();
};
const submitContactForm = async (token, contactForm)=>{
    const form = contactForm;
    const formValues = getFormValues(form);
    const formFields = Object.keys(formValues);
    const errors = validateContactFormData(formValues);
    formFields.forEach((field)=>{
        const input = form.querySelector(`#${field}`);
        removeError(input);
        if (errors[field]) setError({
            element: input,
            message: errors[field]
        });
    });
    if (Object.entries(errors).length > 0) return Promise.reject({
        message: 'Form data invalid',
        errors
    });
    const options = {
        method: 'POST',
        headers: {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json; charset=utf-8'
        },
        body: JSON.stringify({
            ...formValues,
            responseToken: token
        })
    };
    const response = await fetch('http://127.0.0.1:8000/send-message', options);
    return response.json();
};
const toast = document.querySelector('[data-toast]');
const showToast = ({ message, variant, timeout })=>{
    toast.querySelector('.toast__message').innerText = message;
    toast.classList.add('toast--show', variant);
    setTimeout(()=>{
        toast.classList.remove('toast--show', variant);
    }, timeout || 5000);
};
async function initiateContactFormSubmission(token) {
    const contactForm = document.querySelector('[data-contact-form]');
    const submitButton = contactForm.querySelector('.btn');
    try {
        submitButton.innerText = 'Sending...';
        submitButton.setAttribute('disabled', '');
        const { status, message } = await submitContactForm(token, contactForm);
        contactForm.reset();
        window.grecaptcha.reset();
        submitButton.innerText = 'Submit';
        submitButton.removeAttribute('disabled');
        if (status >= 400 && status <= 500) showToast({
            message,
            variant: 'toast--error'
        });
        showToast({
            message,
            variant: 'toast--success'
        });
    } catch (error) {
        showToast({
            message: error.message,
            variant: 'toast--error'
        });
        window.grecaptcha.reset();
        submitButton.innerText = 'Submit';
        submitButton.removeAttribute('disabled');
    }
}
const onChange = (e)=>{
    const errors = validateContactFormData(getFormValues(contactForm));
    removeError(e.target);
    if (errors[e.target.name]) setError({
        element: e.target,
        message: errors[e.target.name]
    });
};
const hamburger = document.querySelector('[data-nav-toggler]');
hamburger.addEventListener('click', handleNavigationToggle);
hamburger.addEventListener('keyup', (e)=>e.key === 'Enter' && handleNavigationToggle());
const navLinks = document.querySelector('[data-nav-links]');
navLinks.addEventListener('click', handleNavigation);
window.addEventListener('scroll', showHideNavbar);
window.addEventListener('load', (e)=>{
    const preloader = document.querySelector('[data-preloader]');
    const animationTime = 5000; // Increase this timer
    const pageLoadTime = e.timeStamp;
    const timeRemainingForAnimation = animationTime - pageLoadTime;
    setTimeout(()=>{
        preloader.classList.add('preloader--ended');
        togglePreventScroll(document.body);
        window.AOS.init({
            delay: 150
        });
    }, timeRemainingForAnimation);
});
toast.addEventListener('mousedown', ()=>{
    toast.classList.add('toast--hiding');
});
toast.addEventListener('mouseup', ()=>{
    toast.classList.remove('toast--hiding', 'toast--show');
});
const contactForm = document.querySelector('[data-contact-form]');
const inputs = document.querySelectorAll('[data-contact-form] .input, [data-contact-form] .text-area');
for(let i = 0; i < inputs.length; i++){
    inputs[i].addEventListener('keyup', onChange);
    inputs[i].addEventListener('blur', onChange);
}
const tagCloudContainer = '.expertise__cloud-container';
const cloudWords = [
    'JavaScript',
    'C#',
    'C/C++',
    'TypeScript',
    'CSS3',
    'AWS',
    'Azure',
    'Git',
    '.NET',
    'NodeJS',
    'ExpressJS',
    'ReactJS',
    'NextJS',
    'NestJS',
    'REST',
    'GraphQL',
    'SQL',
    'NO-SQL',
    'Docker',
    'Kubernetes',
    'DSA'
];
const options = {
    radius: 250,
    maxSpeed: 'fast',
    initSpeed: 'slow',
    keep: false
};
TagCloud(tagCloudContainer, cloudWords, options);

//# sourceMappingURL=Sam-Portfolio.91cec0be.js.map
